import images from 'assets/images';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import type { ICounterProps } from '../types/propTypes';

const CountdownTimer = (props: ICounterProps) => {
    const { holding, onComplete } = props;
    return (
        <CountdownCircleTimer
            isPlaying={holding}
            duration={3}
            size={100}
            rotation="counterclockwise"
            strokeWidth={10}
            isGrowing={true}
            colors={['#d73a1f', '#d73a1f', '#d73a1f', '#d73a1f']}
            colorsTime={[3, 2, 1, 0]}
            onComplete={() => {
                onComplete();
                return { shouldRepeat: false };
            }}
        >
            {({ remainingTime }) =>
                remainingTime > 0 ? (
                    <span className="counter">{remainingTime}</span>
                ) : (
                    <img
                        src={images.checkedIcon}
                        alt="Checked"
                        style={{
                            width: '30px',
                            height: '30px',
                        }}
                    />
                )
            }
        </CountdownCircleTimer>
    );
};

export default CountdownTimer;
